module.exports = __webpack_public_path__ + "assets/img/A5-5-child.a2effa4c.jpg";